export const FAILED = 'FAILED';
export const QUEUED = 'QUEUED';
export const STARTED = 'STARTED';
export const SUCCEEDED = 'SUCCEEDED';
export const SETTLED = 'SETTLED';